import CloseLoopDashboardPage from "../pages/administration/CloseLoopDashboardPage";
import AdministrationAdviceRoutes from "./administration.advice.routes";
import AdministrationAssetAnalysisRoutes from "./administration.analysis.assets.routes";
import AdministrationApplicationRoutes from "./administration.applications.routes";
import AdministrationAssetRoutes from "./administration.assets.routes";
import AdministrationCashBalancesRoutes from "./administration.cashbalances.routes";
import AdministrationCustodianRoutes from "./administration.custodian.routes";
import AdministrationFeesRoutes from "./administration.fees.routes";
import AdministrationNewMoneyRoutes from "./administration.newmoney.routes";
import AdministrationRemindersRoutes from "./administration.reminders.routes";

const AdministrationRoutes = [
    AdministrationAssetAnalysisRoutes,
    {
        path: '/administration/*',
        roles: ['sys_admin_access', 'ho_read', 'ho_write'],
        children: [
            AdministrationNewMoneyRoutes,
            AdministrationApplicationRoutes,
            AdministrationFeesRoutes,
            AdministrationRemindersRoutes,
            AdministrationAssetRoutes,
            AdministrationCustodianRoutes,
            AdministrationAdviceRoutes,
            AdministrationCashBalancesRoutes,
            {
                path: 'close-loop',
                pathBase: '/administration/close-loop',
                defaultRoute: '',
                roles: ['sys_admin_access', 'ho_app_prop'],
                children: [
                    {
                        path: '',
                        element: CloseLoopDashboardPage
                    }
                ]
            }
        ]
    }
];

export default AdministrationRoutes;